import script from "./TableScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./TableScroll.vue?vue&type=script&setup=true&lang=js"

import "./TableScroll.vue?vue&type=style&index=0&id=3f0509cd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0509cd"]])

export default __exports__